import {
  WithSpacingProps,
  withSpacing,
} from 'style-utils/withStyledProps/withSpacingProps';
import {
  WithWidthProps,
  withWidth,
} from 'style-utils/withStyledProps/withWidthProps';
import styled from 'styled-components';

export type StyledFormProps = WithSpacingProps & WithWidthProps;

const StyledForm = styled.form<StyledFormProps>`
  ${withSpacing};
  ${withWidth}
`;

StyledForm.defaultProps = {
  w: '100%',
};

StyledForm.displayName = 'StyledForm';

export default StyledForm;
